import { useEffect } from "react";
import { useAppSelector } from "src/redux/store";
import { isAccessLocked } from "src/utils/accessLock";

/**
 * Locks the whole app for non-PSU GCA entities until the unlock deadline by
 * disabling pointer events on the React root (#root). MUI menus/modals are
 * portaled to <body> (siblings of #root), so they stay interactive — which is
 * how the logout menu keeps working. The profile/logout trigger itself is
 * re-enabled in UserInfo via `pointer-events: auto`. PSU entities and non-GCA
 * users are never locked, and the lock lifts automatically after the deadline.
 */
const AccessLockGate = () => {
  const data = useAppSelector((state) => state.root.user.data);

  const locked = isAccessLocked({
    isGCAEntity: data?.isGCAEntity,
    gcaType: data?.gcaType,
  });

  useEffect(() => {
    const root = document.getElementById("root");
    if (!root) return;
    root.style.pointerEvents = locked ? "none" : "";
    return () => {
      root.style.pointerEvents = "";
    };
  }, [locked]);

  return null;
};

export default AccessLockGate;
